import {
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState, useContext, useEffect, useRef } from "react";
import { Snackbar, Alert } from "@mui/material";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useNavigate } from "react-router-dom";
import { OrderContext } from "../../contexts/OrderContext";
import { Html5QrcodeScanner } from "html5-qrcode";
import CloseIcon from "@mui/icons-material/Close";
import BrandStoneGrid from "./BrandStoneGrid";
import {
  generateJobcardReportPdf,
  buildQuickNoByType,
  entriesFromQrStore,
} from "../../utils/jobcardReportPdf";


const CompleteOrder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { order, completionStatus } = location.state || {};
  const [qrData, setQrData] = useState("");
  const [scanning, setScanning] = useState(false);
  const [showStoneForm, setShowStoneForm] = useState(false);
  const [stoneList, setStoneList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [oldQrData, setOldQrData] = useState(null);

  // Brand-grid stone entry (alternative to the manual "Add Stone" flow).
  const [selectedBrandId, setSelectedBrandId] = useState("");
  const [isGridActive, setIsGridActive] = useState(false);
  // Bumped whenever we load/reset a QR entry, so the grid rehydrates.
  const [entryVersion, setEntryVersion] = useState(0);

  const [isFinalsaveDisable, setIsFinalsaveDisable] = useState(false);

  console.log(completionStatus);

  // const [qrDataStore, setQrDataStore] = useState({});

  const [qrDataStore, setQrDataStore] = useState(() => {
    // Get data from localStorage when the component mounts
    const storedData = localStorage.getItem("qrDataStore");
    return storedData ? JSON.parse(storedData) : {};
  });

  const { storeData, fetchOrders } = useContext(OrderContext);
  const [isEditingPrevious, setIsEditingPrevious] = useState(false);
  const [totalPcsofall, setTotalPcs] = useState(0);
  const [totalstoneofall, setTotalStone] = useState(0);
  const [totalNetwtofall, setTotalNet] = useState(0);
  const [grossWeightofall, setGrossWeight] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [newPcsDetails, setNewPcsDetails] = useState({
    enterlbl: "",
    totalpcs: "",
    sizeLength: "",
    grossWeight: "",
    labelWeight: "",
    stoneWeight: "",
    netWeight: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info", // could be 'success', 'error', 'warning', or 'info'
  });
  const [stoneDetails, setStoneDetails] = useState({
    type: "",
    weight: "",
    weightPerPcs: "",
    description: "",
    stonepcs: "",
  });
  // const [serialNumber, setSerialNumber] = useState(1);

  const [serialNumber, setSerialNumber] = useState(() => {
    // Set serial number dynamically based on the stored data
    const storedData = localStorage.getItem("qrDataStore");
    const parsedData = storedData ? JSON.parse(storedData) : {};
    return Object.keys(parsedData).length + 1;
  });

  const qrScannerRef = useRef(null);

  // Initialize QR Code Scanner
  useEffect(() => {
    if (scanning) {
      const scanner = new Html5QrcodeScanner("qr-reader", {
        qrbox: {
          width: 250,
          height: 250,
        },
        fps: 5,
      });

      scanner.render(onScanSuccess, onScanFailure);
      qrScannerRef.current = scanner;
    }

    return () => {
      if (qrScannerRef.current) {
        qrScannerRef.current.clear();
      }
    };
  }, [scanning]);

  useEffect(() => {
    // console.log("Saving to localStorage:", qrDataStore);
    localStorage.setItem("qrDataStore", JSON.stringify(qrDataStore));
  }, [qrDataStore]);

  useEffect(() => {
    const storedData = localStorage.getItem("qrDataStore");
    if (storedData && storedData !== "{}") {
      // Add check for empty object string.
      setShowModal(true);
    }
  }, []);

  useEffect(() => {
    calculateTotals(qrDataStore);
  }, [qrDataStore]);

  const calculateTotals = (data) => {
    let totalPcs = 0;
    let grossWeight = 0;
    let totalNetWt = 0;
    let totalStone = 0;

    Object.values(data).forEach(({ pcsDetails }) => {
      totalPcs += pcsDetails?.totalpcs ? parseInt(pcsDetails.totalpcs) : 0;
      grossWeight += pcsDetails?.labelWeight
        ? parseFloat(pcsDetails.labelWeight)
        : 0;
      totalStone += pcsDetails?.stoneWeight
        ? parseFloat(pcsDetails.stoneWeight)
        : 0;
      totalNetWt += pcsDetails?.netWeight
        ? parseFloat(pcsDetails.netWeight)
        : 0;
    });

    // Update state
    setTotalPcs(totalPcs);
    setGrossWeight(grossWeight);
    setTotalNet(totalNetWt);
    setTotalStone(totalStone);
  };

  // Handle QR Code Scan Success
  const onScanSuccess = async (decodedText) => {
    setScanning(false);

    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/fetchorder/check-qrcode/${decodedText}`
    );

    if (response.data.exists) {
      // 🚨 QR Code already exists - Show error message

      setSnackbar({
        open: true,
        message: "QR Code already exists in the database!",
        severity: "error",
      });
      return;
    }

    setQrData(decodedText);

    if (qrDataStore[decodedText]) {
      const { pcsDetails, stoneList, brandId } = qrDataStore[decodedText];
      setNewPcsDetails(pcsDetails);
      setStoneList(stoneList);
      setSelectedBrandId(brandId || "");
      setEntryVersion((v) => v + 1);
    }
  };

  const handleClearData = () => {
    localStorage.removeItem("qrDataStore");
    setQrDataStore({});
    setSerialNumber(1);
    console.log("Previous data removed.");
    setShowModal(false);
  };

  const handleKeepData = () => {
    console.log("Previous data retained.");
    setShowModal(false);
  };

  // Handle QR Code Scan Failure
  const onScanFailure = (error) => {
    console.warn(`QR scan error: ${error}`);
  };

  // Handle Manual QR Code Input
  const handleManualQrCodeInput = async (e) => {
    const enteredQrCode = e.target.value;
    setQrData(enteredQrCode);

    try {
      if (!enteredQrCode) return; // Don't check if the field is empty

      if (
        qrDataStore.hasOwnProperty(enteredQrCode) &&
        enteredQrCode !== oldQrData
      ) {
        setTimeout(() => {
          setSnackbar({
            open: true,
            message: "QR Code already used in local entries!",
            severity: "error",
          });
        }, 500);

        setQrData("");
        return;
      }

      // ✅ Step 1: Check if QR Code exists in the database
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/fetchorder/check-qrcode/${enteredQrCode}`
      );

      if (response.data.exists) {
        setTimeout(() => {
          setSnackbar({
            open: true,
            message: "QR Code already used in Database!",
            severity: "error",
          });
        }, 100);
        setQrData("");
        return;
      }

      // ✅ Step 2: If QR Code is new, proceed with normal logic
      if (qrDataStore[enteredQrCode]) {
        const { pcsDetails, stoneList, brandId } = qrDataStore[enteredQrCode];
        setNewPcsDetails(pcsDetails);
        setStoneList(stoneList);
        setSelectedBrandId(brandId || "");
        setEntryVersion((v) => v + 1);
      }
    } catch (error) {
      console.error("Error checking QR Code:", error);

      setSnackbar({
        open: true,
        message: "Error verifying QR Code. Please try again.",
        severity: "error",
      });
    }
  };

  // Start QR Code Scanning
  const handleStartScan = () => {
    setScanning(true);
  };

  // Stop QR Code Scanning
  const handleStopScan = () => {
    setScanning(false);
    if (qrScannerRef.current) {
      qrScannerRef.current.clear();
    }
  };

  // Save or Update Data for the Current QR Code
  const handleSaveData = () => {
    return new Promise((resolve) => {
      setQrDataStore((prevStore) => {
        const updatedStore = { ...prevStore };
        updatedStore[qrData] = {
          pcsDetails: newPcsDetails,
          stoneList,
        };

        let totalPcs = 0;
        let grossWeight = 0;
        let totalNetWt = 0;
        let totalStone = 0;

        Object.values(updatedStore).forEach(({ pcsDetails }) => {
          totalPcs += pcsDetails?.totalpcs ? parseInt(pcsDetails.totalpcs) : 0;
          grossWeight += pcsDetails?.labelWeight
            ? parseFloat(pcsDetails.labelWeight)
            : 0;
          totalStone += pcsDetails?.stoneWeight
            ? parseFloat(pcsDetails.stoneWeight)
            : 0;
          totalNetWt += pcsDetails?.netWeight
            ? parseFloat(pcsDetails.netWeight)
            : 0;
        });

        // Update total PCS & Gross Weight states
        setTotalPcs(totalPcs);
        setGrossWeight(grossWeight);
        setTotalNet(totalNetWt);
        setTotalStone(totalStone);

        resolve(updatedStore); // Resolve after state update
        return updatedStore;
      });
    });
  };

  const handleAddNext = async () => {
    const trimmedQrData = (qrData || "").trim();
    const trimmedOldQrData = (oldQrData || "").trim();
    const isEditingSameQR = trimmedQrData === trimmedOldQrData;
    const existingEntry = qrDataStore[trimmedQrData];

    // Case 1: Adding new entry (not editing) and QR already exists
    if (!isEditingPrevious && existingEntry) {
      setSnackbar({
        open: true,
        message: "QR Code already used in local entries!",
        severity: "error",
      });
      return;
    }

    // Case 2: Editing but trying to use a *different* QR that already exists
    if (isEditingPrevious && !isEditingSameQR && existingEntry) {
      setQrData(oldQrData);
      setSnackbar({
        open: true,
        message: "QR Code already used in local entries!",
        severity: "error",
      });
      return;
    }

    // Case 3: Required fields check (PCS is no longer required — it defaults
    // to 1 below when left blank)
    if (
      (!trimmedQrData && !isEditingSameQR) || // if QR is empty and not editing the same one
      !newPcsDetails.grossWeight
    ) {
      setQrData(oldQrData);
      setSnackbar({
        open: true,
        message: "QR Code and Gross Weight are required!",
        severity: "error",
      });
      return;
    }

    try {
      // Only check with backend if:
      // - Not editing, OR
      // - Editing but changing the QR
      if (!isEditingPrevious || (isEditingPrevious && !isEditingSameQR)) {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/fetchorder/check-qrcode/${trimmedQrData}`
        );

        if (response.data.exists) {
          setSnackbar({
            open: true,
            message: "QR Code already exists in the database!",
            severity: "error",
          });
          return;
        }
      }

      // Update local store
      const updatedStore = { ...qrDataStore };

      // If editing and changed QR, remove old one
      if (
        isEditingPrevious &&
        trimmedOldQrData &&
        trimmedQrData !== trimmedOldQrData
      ) {
        delete updatedStore[trimmedOldQrData];
      }

      // Add/Update entry (brandId is local-only; the backend ignores it).
      // Default PCS to 1 when the karigar left it blank.
      const pcsDetailsToSave = {
        ...newPcsDetails,
        totalpcs: newPcsDetails.totalpcs || "1",
      };
      updatedStore[trimmedQrData] = {
        pcsDetails: pcsDetailsToSave,
        stoneList: stoneList,
        brandId: selectedBrandId,
      };

      localStorage.setItem("qrDataStore", JSON.stringify(updatedStore));
      setQrDataStore(updatedStore);

      // Scroll back to the top so the next entry starts from the QR field.
      window.scrollTo({ top: 0, behavior: "smooth" });

      const totalRecords = Object.keys(updatedStore).length;

      // If editing and next record exists, load it
      if (isEditingPrevious && serialNumber < totalRecords) {
        const keys = Object.keys(updatedStore);
        const nextIndex = serialNumber; // serialNumber is 1-based
        if (nextIndex < keys.length) {
          const nextQrData = keys[nextIndex];
          const nextData = updatedStore[nextQrData];

          if (nextData) {
            setQrData(nextQrData);
            setNewPcsDetails(nextData.pcsDetails);
            setStoneList(nextData.stoneList);
            setSelectedBrandId(nextData.brandId || "");
            setEntryVersion((v) => v + 1);
            setSerialNumber(nextIndex + 1); // move forward correctly
            setOldQrData(nextQrData);
            setIsEditingPrevious(true);

            setSnackbar({
              open: true,
              message: "Successfully saved the entry.",
            });
            return; // 🟢 Add return to skip reset block below
          }
        }
      } else {
        // Reset to prepare new entry
        setSerialNumber(totalRecords + 1);
        setIsEditingPrevious(false);
        setQrData("");

        setOldQrData(null);
        setStoneList([]);
        // Keep the selected brand for the next SL.No; bumping entryVersion with
        // an empty stoneList rebuilds the same brand's grid with zero values,
        // which the karigar can edit or change the brand if they wish.
        setEntryVersion((v) => v + 1);
        setNewPcsDetails({
          enterlbl: newPcsDetails.enterlbl, // carry Label Weight forward
          totalpcs: "",
          sizeLength: "",
          grossWeight: "",
          labelWeight: "",
          stoneWeight: "",
          netWeight: "",
        });
        setStoneDetails({
          type: "",
          weight: "",
          weightPerPcs: "",
          description: "",
          stonepcs: "",
        });
        setEditIndex(null);
        setSnackbar({ open: true, message: "Successfully saved the entry." });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Error checking QR code. Please try again.",
        severity: "error",
      });
    }
  };

  const handleEditPrevious = () => {
    const keys = Object.keys(qrDataStore);
    if (keys.length < 1 || serialNumber === 1) return; // Prevent going before the first entry

    const prevIndex = serialNumber - 2; // Serial number is 1-based, array is 0-based
    const prevQrData = keys[prevIndex]; // Get previous QR code
    const prevData = qrDataStore[prevQrData];

    if (prevData) {
      setQrData(prevQrData);
      setNewPcsDetails(prevData.pcsDetails);
      setStoneList(prevData.stoneList);
      setSelectedBrandId(prevData.brandId || "");
      setEntryVersion((v) => v + 1);
      setSerialNumber((prev) => prev - 1);
      setIsEditingPrevious(true);
      setOldQrData(prevQrData);
    }
  };

  // Calculate Total Stone Weight. Stones marked "Other" are still saved with
  // their real weight, but are excluded from this sum so they don't reduce the
  // Net Weight (Net = Gross - this sum) or show in the Stone Weight box.
  const isOtherStone = (stone) =>
    (stone?.description || "").trim().toLowerCase() === "other";
  const totalStoneWeight = stoneList.reduce(
    (total, stone) =>
      isOtherStone(stone) ? total : total + parseFloat(stone.weight || 0),
    0
  );

  useEffect(() => {
    setNewPcsDetails((prevDetails) => {
      const updatedDetails = {
        ...prevDetails,
        stoneWeight: totalStoneWeight,
      };
      updatedDetails.netWeight =
        updatedDetails.grossWeight - updatedDetails.stoneWeight; // Recalculate netWeight here
      return updatedDetails;
    });
  }, [totalStoneWeight, newPcsDetails.grossWeight]);

  // Handle PCS Details Change
  const handlePcsDetailsChange = (e) => {
    const { name, value } = e.target;
    setNewPcsDetails((prevState) => {
      const updatedPcsDetails = { ...prevState, [name]: value };
      // console.log(updatedPcsDetails);

      if (name === "enterlbl" || name === "labelWeight") {
        const labelWeight = updatedPcsDetails.enterlbl;
        updatedPcsDetails.grossWeight = parseFloat(
          (updatedPcsDetails.labelWeight - labelWeight).toFixed(3)
        );
        updatedPcsDetails.netWeight = parseFloat(
          (
            updatedPcsDetails.grossWeight - updatedPcsDetails.stoneWeight
          ).toFixed(3)
        );
      }
      if (name === "stoneWeight") {
        updatedPcsDetails.netWeight =
          updatedPcsDetails.grossWeight - updatedPcsDetails.stoneWeight;
      }
      return updatedPcsDetails;
    });
  };

  const handleStoneChange = (e) => {
    const { name, value } = e.target;

    // Update state with new input value
    setStoneDetails((prevDetails) => {
      const updatedDetails = {
        ...prevDetails,
        [name]: value,
      };

      // Auto-calculate Stone Weight if stonepcs or weightPerPcs changes
      if (name === "stonepcs" || name === "weightPerPcs") {
        const stonepcs = parseFloat(updatedDetails.stonepcs) || 0;
        const weightPerPcs = parseFloat(updatedDetails.weightPerPcs) || 0;
        updatedDetails.weight = (stonepcs * weightPerPcs).toFixed(3); // Keeping two decimal places
      }

      return updatedDetails;
    });
  };

  // Grid → parent bridge. While the grid is active it fully owns stoneList.
  // On a user-driven deactivation (brand cleared) we reset to a clean slate so
  // the manual form starts fresh; a rehydrate ("init") never touches stoneList.
  const handleGridChange = ({ brandId, stoneList: gridStoneList, active, source }) => {
    setSelectedBrandId(brandId);
    setIsGridActive(active);
    if (active) {
      setStoneList(gridStoneList);
    } else if (source === "user") {
      setStoneList([]);
    }
  };

  // Handle Add Stone
  const handleAddStone = () => {
    if (!stoneDetails.type || !stoneDetails.weight || !stoneDetails.stonepcs) {
      setSnackbar({
        open: true,
        message: "Please enter all stone details.",
        severity: "error",
      });
      return;
    }
    const updatedStoneList = [...stoneList];
    if (editIndex !== null) {
      updatedStoneList[editIndex] = stoneDetails;
      setEditIndex(null);
    } else {
      updatedStoneList.push(stoneDetails);
    }
    setStoneList(updatedStoneList);
    setStoneDetails({
      type: "",
      weight: "",
      weightPerPcs: "",
      description: "",
      stonepcs: "",
    });
    setShowStoneForm(false);
  };

  // Handle Edit Stone
  const handleEditStone = (index) => {
    setStoneDetails(stoneList[index]);
    setEditIndex(index);
    setShowStoneForm(true);
  };

  // Handle Delete Stone
  const handleDeleteStone = (index) => {
    const updatedList = stoneList.filter((_, i) => i !== index);
    setStoneList(updatedList);
  };

  // Handle Finish Button
  const handleFinish = async () => {
    setIsFinalsaveDisable(true);
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        setSnackbar({
          open: true,
          message: "Unauthorized! Please log in again.",
          severity: "error",
        });
        setIsFinalsaveDisable(false);
        return;
      }

      if (!order?.storeorderno || !order?.orderid) {
        setSnackbar({
          open: true,
          message: "Missing order details. Please try again.",
          severity: "error",
        });
        setIsFinalsaveDisable(false);

        return;
      }

      const requiredKeys = Object.keys(qrDataStore); // Get all the keys dynamically from qrDataStore

      if (
        !qrDataStore ||
        typeof qrDataStore !== "object" ||
        Object.keys(qrDataStore).filter((key) => key.trim() !== "").length === 0
      ) {
        setSnackbar({
          open: true,
          message: "Please Enter QR code Data.",
          severity: "error",
        });
        setIsFinalsaveDisable(false);

        return;
      }

      // Loop through each key and validate its presence and structure
      for (let key of requiredKeys) {
        const keyData = qrDataStore[key];
        if (!keyData || !keyData.pcsDetails) {
          setSnackbar({
            open: true,
            message: `Missing or incomplete data for order ID ${key}. Please ensure all required fields are filled.`,
            severity: "error",
          });
          setIsFinalsaveDisable(false);

          return;
        }
      }

      const payload = {
        ...qrDataStore,
        storeorderno: order?.storeorderno,
        orderid: order?.orderid,
        completionStatus: completionStatus,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/kariagr`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { success, message } = response.data;
      if (success) {
        setSnackbar({
          open: true,
          message: message || "Order saved successfully!",
          severity: "success",
        });
        // Generate the printable Jobcard PDF from the saved entries before the
        // local store is cleared below.
        try {
          const storeName =
            JSON.parse(localStorage.getItem("selectedMfr"))?.storeDetails
              ?.name || "";
          const karigarName =
            order?.karigar_name ||
            JSON.parse(localStorage.getItem("user"))?.name ||
            "";
          generateJobcardReportPdf({
            orderNo: order?.storeorderno,
            storeName,
            karigarName,
            entries: entriesFromQrStore(qrDataStore),
            quickNoByType: buildQuickNoByType(storeData?.stone),
          });
        } catch (pdfErr) {
          console.error("Jobcard PDF generation failed:", pdfErr);
        }
        setQrDataStore({});
        setQrData("");
        setStoneList([]);
        setSelectedBrandId("");
        setIsGridActive(false);
        setEntryVersion((v) => v + 1);
        setNewPcsDetails({
          totalpcs: "",
          sizeLength: "",
          grossWeight: "",
          labelWeight: "",
          stoneWeight: "",
          netWeight: "",
        });
        setStoneDetails({
          type: "",
          weight: "",
          weightPerPcs: "",
          description: "",
          stonepcs: "",
        });
        setEditIndex(null);
        setShowStoneForm(false);
        setTimeout(() => {
          fetchOrders();
          navigate("/home");
        }, 1000);
      } else {
        console.error("resp erro:", message);
        setIsFinalsaveDisable(false);

        setSnackbar({
          open: true,
          message: `Error: ${message}`,
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error:", error);

      setSnackbar({
        open: true,
        message: error?.response?.data?.message,
        severity: "error",
      });
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 1, mb: 1 }}>
      <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          {/* <Typography variant="body1">
                        Enter QR code:
                    </Typography> */}
          <TextField
            label="Enter QR Code"
            value={qrData}
            onChange={(e) => setQrData(e.target.value)}
            onBlur={handleManualQrCodeInput}
            fullWidth
            sx={{ ml: 2 }}
          // disabled={isEditingPrevious}
          />
          <Button
            variant="contained"
            onClick={scanning ? handleStopScan : handleStartScan}
            sx={{ height: "56px" }}
          // disabled={isEditingPrevious} // Disables button when isEditingPrevious is true
          >
            {scanning ? "Stop Scan" : "Start Scan"}
          </Button>
        </Box>

        {scanning && <Box id="qr-reader" sx={{ mt: 2 }}></Box>}

        {/* Display Order Info */}
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={4}>
            <Typography variant="h6">SL.NO</Typography>
            {serialNumber}
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h6">Order No</Typography>
            {order?.storeorderno}
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h6">QR.NO</Typography>
            {qrData}
          </Grid>
        </Grid>

        {/* PCS and Weight Info */}
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="PCS"
                name="totalpcs"
                value={newPcsDetails.totalpcs}
                onChange={handlePcsDetailsChange}
                fullWidth
                type="tel" // Ensures numeric keyboard on mobile
                inputMode="numeric" // Hints to use numeric keyboard
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Size/Length"
                name="sizeLength"
                value={newPcsDetails.sizeLength}
                onChange={handlePcsDetailsChange}
                fullWidth
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={6}>
              <TextField
                label="Label Weight"
                name="enterlbl"
                type="number"
                value={newPcsDetails.enterlbl}
                onChange={handlePcsDetailsChange}
                fullWidth
                InputLabelProps={{ shrink: !!newPcsDetails.enterlbl }}
              />
            </Grid>
          </Grid>

          {/* Gross Weight and Net Weight */}
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={6}>
              <TextField
                label="Gross + Label Wt"
                name="labelWeight"
                type="number"
                value={newPcsDetails.labelWeight}
                onChange={handlePcsDetailsChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Gross Weight"
                name="grossWeight"
                type="number"
                fullWidth
                value={
                  parseFloat(newPcsDetails.grossWeight) > 0
                    ? newPcsDetails.grossWeight
                    : ""
                }
                onChange={(e) => {
                  setNewPcsDetails({
                    ...newPcsDetails,
                    grossWeight: e.target.value, // Allow any input here
                  });
                }}
                onBlur={() => {
                  const inputValue = newPcsDetails.grossWeight;
                  const value = parseFloat(inputValue);

                  setNewPcsDetails({
                    ...newPcsDetails,
                    grossWeight:
                      isNaN(value) || value <= 0 ? "" : value.toFixed(3), // Simplified check and directly set toFixed
                  });
                }}
                // Add these properties to improve user experience
                inputProps={{
                  step: "any", // Allows decimal input
                  min: 0, // Sets a minimum value if needed
                }}
                // Optional: Add error handling for invalid input
                error={
                  isNaN(parseFloat(newPcsDetails.grossWeight)) &&
                  newPcsDetails.grossWeight !== ""
                } // Check for NaN and not empty
                helperText={
                  isNaN(parseFloat(newPcsDetails.grossWeight)) &&
                    newPcsDetails.grossWeight !== ""
                    ? "Invalid input"
                    : ""
                }
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={6}>
              <TextField
                label="Stone Weight"
                name="stoneWeight"
                type="number"
                // value={newPcsDetails.stoneWeight}
                value={
                  newPcsDetails.stoneWeight
                    ? Number(newPcsDetails.stoneWeight).toFixed(3)
                    : ""
                }
                onChange={handlePcsDetailsChange}
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Net Weight"
                name="netWeight"
                type="number"
                value={
                  newPcsDetails.netWeight > 0
                    ? parseFloat(newPcsDetails.netWeight).toFixed(3)
                    : "" // Hide if zero or negative
                }
                fullWidth
                disabled
              />
            </Grid>
          </Grid>

          {/* Brand-driven stone grid (alternative to the manual flow) */}
          <BrandStoneGrid
            brands={storeData?.brand || []}
            stones={storeData?.stone || []}
            value={{ brandId: selectedBrandId, stoneList }}
            entryKey={entryVersion}
            onChange={handleGridChange}
          />

          {/* Stone Info and Total Weight Display */}
          {!isGridActive && (
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Button
                variant="contained"
                sx={{ fontWeight: "bold", textTransform: "none" }}
                onClick={() => setShowStoneForm(true)}
              >
                Add stone Details
              </Button>
              {showStoneForm && (
                <IconButton onClick={() => setShowStoneForm(false)}>
                  <CloseIcon />
                </IconButton>
              )}
            </Box>
          )}

          {!isGridActive && showStoneForm && (
            <Box sx={{ mt: 2 }}>
              <FormControl fullWidth sx={{ mb: 1 }}>
                <InputLabel id="stone-type-label">Stone Type</InputLabel>
                <Select
                  name="type"
                  labelId="stone-type-label" // Link label with the Select component
                  value={stoneDetails.type || ""} // Ensure the value is always a string or empty
                  onChange={handleStoneChange}
                  label="Stone Type"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        textAlign: "left", // Align the dropdown items to the left
                      },
                    },
                  }}
                  sx={{ textAlign: "left" }}
                >
                  {storeData?.stone?.map((stone) => (
                    <MenuItem key={stone.id} value={stone.Stone_name}>
                      {stone.Stone_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Description"
                name="description"
                value={stoneDetails.description}
                onChange={handleStoneChange}
                fullWidth
                sx={{ mb: 1 }}
              />
              <TextField
                label="Pcs"
                name="stonepcs"
                value={stoneDetails.stonepcs}
                onChange={handleStoneChange}
                fullWidth
                sx={{ mb: 1 }}
                type="tel" // Ensures numeric keyboard on mobile
                inputMode="numeric" // Hints to use numeric keyboard
                onKeyDown={(e) => {
                  // Allow: backspace, delete, tab, escape, enter, arrows
                  if (
                    [
                      "Backspace",
                      "Delete",
                      "Tab",
                      "Escape",
                      "Enter",
                      "ArrowLeft",
                      "ArrowRight",
                    ].includes(e.key)
                  ) {
                    return;
                  }

                  // Prevent non-numeric input
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                inputProps={{ pattern: "[0-9]*" }} // Helps with mobile devices
              />
              <TextField
                label="Weight Per Pc"
                name="weightPerPcs"
                value={stoneDetails.weightPerPcs}
                onChange={handleStoneChange}
                fullWidth
                sx={{ mb: 2 }}
                type="number"
              />
              <TextField
                label="Stone Weight"
                name="weight"
                type="number"
                value={stoneDetails.weight}
                onChange={handleStoneChange}
                fullWidth
                sx={{ mb: 1 }}
              />

              <Button variant="contained" onClick={handleAddStone}>
                {editIndex !== null ? "Update" : "Add"}
              </Button>
            </Box>
          )}

          {/* Stone List Table */}
          {!isGridActive && (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Type</TableCell>
                    <TableCell>PCS</TableCell>
                    <TableCell>W/Pcs</TableCell>
                    <TableCell>Weight</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stoneList.map((stone, index) => (
                    <TableRow key={index}>
                      <TableCell>{stone.type}</TableCell>
                      <TableCell>{stone.stonepcs}</TableCell>
                      <TableCell>{stone.weightPerPcs}</TableCell>
                      <TableCell>{stone.weight}</TableCell>

                      <TableCell>
                        <Box sx={{ display: "flex", gap: 0.5 }}>
                          <IconButton onClick={() => handleEditStone(index)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton onClick={() => handleDeleteStone(index)}>
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {/* Finish and Add Next Buttons */}
          <Box
            sx={{
              mt: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* Edit Previous & Add Next in One Row */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center",
                width: "100%",
                mb: 2,
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                onClick={handleEditPrevious}
                disabled={
                  Object.keys(qrDataStore).length === 0 || serialNumber === 1
                }
                sx={{ minWidth: 150 }} // Ensures equal button width
              >
                Edit Previous
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleAddNext}
                sx={{ minWidth: 150 }} // Ensures equal button width
              >
                Add Next
              </Button>
            </Box>

            {/* Final Save Below */}
            <Button
              variant="contained"
              color="success"
              onClick={handleFinish}
              disabled={
                Object.keys(qrDataStore).length === 0 || isFinalsaveDisable
              }
              sx={{ minWidth: 320, mt: 1 }} // Wider button and margin-top for separation
            >
              Final Save
            </Button>
          </Box>

          <Box
            sx={{
              mt: 2,
              p: 2,
              bgcolor: "#f5f5f5",
              borderRadius: 2,
              boxShadow: 2,
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)", // Two columns per row
              gap: 2, // Space between items
              textAlign: "center",
            }}
          >
            {/* Row 1 */}
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", color: "#555" }}
              >
                PCS
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontWeight: "normal", color: "#222" }}
              >
                {totalPcsofall}
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", color: "#555" }}
              >
                Gross Weight
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontWeight: "normal", color: "#222" }}
              >
                {grossWeightofall.toFixed(3)}
              </Typography>
            </Box>

            {/* Row 2 */}
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", color: "#555" }}
              >
                Stone Weight
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontWeight: "normal", color: "#222" }}
              >
                {totalstoneofall.toFixed(3)}
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", color: "#555" }}
              >
                Net Weight
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontWeight: "normal", color: "#222" }}
              >
                {totalNetwtofall.toFixed(3)}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Running summary of every entry added so far */}
        {Object.keys(qrDataStore).filter((qr) => qr.trim() !== "").length >
          0 && (
          <Box sx={{ mt: 3 }}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", mb: 1, textAlign: "left" }}
            >
              Added Entries
            </Typography>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>SL</TableCell>
                    <TableCell>QR No</TableCell>
                    <TableCell>Gross Wt</TableCell>
                    <TableCell>Net Wt</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(qrDataStore)
                    .filter(([qr]) => qr.trim() !== "")
                    .map(([qr, entry], idx) => {
                      const p = entry.pcsDetails || {};
                      const fmt = (v) =>
                        v || v === 0 ? Number(v).toFixed(3) : "";
                      return (
                        <TableRow key={qr}>
                          <TableCell>{idx + 1}</TableCell>
                          <TableCell>{qr}</TableCell>
                          <TableCell>{fmt(p.grossWeight)}</TableCell>
                          <TableCell>{fmt(p.netWeight)}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </Paper>
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
            }}
          >
            <p style={{ fontSize: "1.1rem", marginBottom: "20px" }}>
              Previous data exists. Do you want to remove it?
            </p>
            <div
              style={{ display: "flex", justifyContent: "center", gap: "16px" }}
            >
              <button
                onClick={handleClearData}
                style={{
                  backgroundColor: "#dc3545",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Remove
              </button>
              <button
                onClick={handleKeepData}
                style={{
                  backgroundColor: "#28a745",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Keep
              </button>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() =>
          setSnackbar({ open: false, message: "", severity: "info" })
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{
          "& .MuiPaper-root": {
            minWidth: 360,
            maxWidth: 600,
            padding: 2,
            fontSize: "1.25rem", // Bigger font
          },
          bottom: 80, // Moved higher from bottom
        }}
      >
        <Alert
          onClose={() =>
            setSnackbar({ open: false, message: "", severity: "info" })
          }
          severity={snackbar.severity}
          sx={{
            fontSize: "1.25rem", // Bigger text in Alert
            py: 2,
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default CompleteOrder;
